let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("8JZKd"), load("ljaqI"), load("3W8o1")]).then(() => parcelRequire('eMG9c'));